import React from 'react'

const CTA = () => {
  return (
    <div className="cta">
        <a href="tel:+9694037795" className="btn btn-primary">Let's Talk</a>
    </div>
  )
}

export default CTA
